import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { Connection } from '@/types/connection';
import ListArrows from '@/components/common/ListArrows';
import TextFieldWrapper from '@/components/common/TextFieldWrapper';

type FixedListItemProps = {
  action: string;
  label: string;
  data: Connection[];
  index: number;
  onArrowClick: (data: Connection[]) => void;
  onChange: (label: string) => void;
};

const FixedListItem: FC<FixedListItemProps> = (props) => {
  return (
    <Stack direction='row' gap={1} alignItems='center'>
      <Typography variant='body1' flexGrow={1} textAlign='end' width='100%'>
        {props.action}
      </Typography>
      <TextFieldWrapper
        size='small'
        label='Label'
        value={props.label}
        sx={{ flexGrow: 1 }}
        fullWidth
        onChange={(event) => props.onChange(event.currentTarget.value)}
      />
      <ListArrows data={props.data} index={props.index} onChange={props.onArrowClick} />
      <IconButton disabled sx={{ opacity: 0 }}>
        <ClearIcon />
      </IconButton>
    </Stack>
  );
};

export default FixedListItem;
